// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CommsThreadEventAttachments from './data'

export default function CommsThreadEventAttachmentsFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CommsThreadEventAttachments">
      <CommsThreadEventAttachments {...props}>
        {children}
      </CommsThreadEventAttachments>
    </Flow>
  )
}
